import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AppConfigService } from '@app/app-config.service';
import { LoginStateService } from '@app/features/auth/services/login.state.service';
import { Observable } from 'rxjs';
import { LoginSamlService, SamlRedirectInfo } from '../login.saml.service';

@Injectable()
export class LoginSamlServiceImpl implements LoginSamlService {
  constructor(
    @Inject('LoginStateService') protected loginStateService: LoginStateService,
    protected http: HttpClient,
    protected router: Router,
    protected appConfigService: AppConfigService
  ) {}

  /**
   * Perform a request to get SAML info
   */
  getRequestInfo(): Observable<any> {
    return this.http.get<any>(`${this.appConfigService.getApi()}/auth/sso/SAMLRequest/` + new Date().toISOString());
  }

  /**
   * Redirect adding the SAMLRequest parameter
   */
  redirect() {
    this.getRequestInfo().subscribe(ret => {
      let val: SamlRedirectInfo = ret;
      this.loginStateService.setAdfsToken(val);
      window.location.replace(val.samlURL + '?SAMLRequest=' + encodeURIComponent(val.requestParameters));
    });
  }
}
